import { Section } from '../components/Section';
import { SPONSORS } from '../data/sponsors';

export function Sponsors(): JSX.Element {
  return (
    <Section label="HOSTED BY · BACKED BY" title={<>The sponsors keeping the bath water warm.</>} background="paper">
      <div className="grid gap-3" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))' }}>
        {SPONSORS.map((s) =>
          s.primary ? (
            <div
              key={s.name}
              className="relative flex flex-col gap-3 rounded-xl border-2 border-ink p-6"
              style={{ gridColumn: 'span 2', background: '#000', boxShadow: '4px 4px 0 rgb(var(--color-ink))' }}
            >
              <div className="absolute font-mono text-[10px] font-bold uppercase tracking-[0.18em] text-duck" style={{ top: 12, right: 14 }}>
                Presenting partner
              </div>
              {s.logo && (
                <img
                  src={s.logo}
                  alt={s.name}
                  className="mt-1 self-start object-contain"
                  style={{ height: 44, objectPosition: 'left center', maxWidth: '70%' }}
                />
              )}
              <div className="font-mono text-xs text-[#cfcfcf]">{s.tag}</div>
            </div>
          ) : (
            <div
              key={s.name}
              className="rounded-xl border-2 border-dashed border-[rgb(var(--color-ink)/12%)] bg-bg p-5"
            >
              <div className="font-display text-[22px] font-extrabold text-ink">{s.name}</div>
              <div className="mt-1 font-mono text-xs text-ink-soft">{s.tag}</div>
            </div>
          ),
        )}
        <div className="flex flex-col justify-center rounded-xl border-2 border-ink bg-duck p-5">
          <div className="font-display text-lg font-extrabold text-ink">Your logo here?</div>
          <div className="mt-1 text-[13px] text-ink">Sponsor a season →</div>
        </div>
      </div>
    </Section>
  );
}
